import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: {},
});

export default useSx;
